import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Card, Container, Row, Col, Spinner } from "react-bootstrap";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from "react-i18next";
import { getToken } from "../../utils/auth";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function QrCodePage() {
  const [reservations, setReservations] = useState([]);
  const [fetching, setFetching] = useState(false);
    const { t, i18n } = useTranslation();

  const fetchReservations = async () => {
    setFetching(true);
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/social-net/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setReservations(response.data?.data || []);
    } catch (error) {
      toast.error("Failed to fetch QR Code.");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchReservations();
  }, []);

  const styles = {
    pageContainer: {
      backgroundColor: "#f8f9fa",
      padding: "20px",
      minHeight: "100vh",
    },
    header: {
      textAlign: "center",
      marginBottom: "20px",
    },
    headerTitle: {
      fontSize: "2rem",
      fontWeight: "bold",
    },
    headerDescription: {
      color: "#6c757d",
    },
    spinnerContainer: {
      textAlign: "center",
      margin: "50px 0",
    },
    gridRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      justifyContent: "center",
      marginTop: "20px",
    },
    card: {
      border: "1px solid #ddd",
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      padding: "15px",
      textAlign: "center",
      width: "300px",
    },
    qrInfo: {
      fontSize: "1rem",
      marginBottom: "10px",
    },
    qrImageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    qrImage: {
      width: "100px",
      height: "100px",
    },
    emptyState: {
      textAlign: "center",
      color: "#6c757d",
      fontSize: "1.2rem",
      marginTop: "50px",
    },
  };

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
<div style={styles.pageContainer}>
        <Container>
          <header style={styles.header}>
            <h1 style={styles.headerTitle}>{t("reserved_qrc_id")}</h1>
            {/* <p style={styles.headerDescription}>{t("qr_code_page_description")}</p> */}
          </header>

          {fetching ? (
            <div style={styles.spinnerContainer}>
              <Spinner animation="border" role="status" />
              <p>{t("loading_message")}</p>
            </div>
          ) : (
            <div style={styles.gridRow}>
              {reservations.length > 0 ? (
                reservations.map((reservation) => (
                  <Card key={reservation?._id} style={styles.card}>
                    <Card.Body>
                      <div style={styles.qrInfo}>
                        <strong>{t("qrc")}: </strong>
                        {reservation?.qrc_UID}
                      </div>
                      <div style={styles.qrImageContainer}>
                        <img
                          src={reservation?.qrCodeUrl}
                          alt="QR Code"
                          style={styles.qrImage}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                ))
              ) : (
                <div style={styles.emptyState}>
                  <p>{t("no_qr_codes_message")}</p>
                </div>
              )}
            </div>
          )}
        </Container>
      </div>
    </>
  );
}
